import { render, staticRenderFns } from "./StockAdjustmentCreateView.vue?vue&type=template&id=6ed080d1"
import script from "./StockAdjustmentCreateView.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports